import api from "./api";

export function getGeneratedQR() {
    return api.post(`/auth/createsession`);
}

export function QRLogin(data) {
    return api.post(`/auth/qrlogin`, data);
}
